// Utilities
import { lazy } from "react";
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
export const SuiteNavContainerLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "uno-suitenavcontainer" */ "./SuiteNavContainer")).then((page)=>{
        return {
            default: page.SuiteNavContainer
        };
    });
export const LazySuiteNavContainer = /*#__PURE__*/ lazy(SuiteNavContainerLazyLoader);
